module.exports = __webpack_public_path__ + "static/img/carousel_2_klrq02_ar_16_9_w_2400.7ffb4ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_2_klrq02_ar_16_9_w_2400.jpg
// module id = coo7
// module chunks = 0